import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { SharedService } from '../../../services/shared.service';
import { ChatService } from 'src/app/services/chat.service';
const emails = require('../../../services/emails.json');
import * as moment from "moment-timezone";

@Component({
  selector: 'app-support-plan-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss']
})
export class SupportPlanItemComponent implements OnInit, OnDestroy {
  plan: any = undefined;
  showStopForm: boolean = false;
  stopReason: string = '';

  constructor(
    public auth: AuthService,
    private shared: SharedService,
    private cs: ChatService
  ) {}

  ngOnInit() {
    if (this.shared.getCookie(SharedService.CURRENT_SUPPORT_PLAN)) {
      this.plan = this.shared.getCookie(SharedService.CURRENT_SUPPORT_PLAN)
    } else {
      window.history.back();
    }
  }

  ngOnDestroy() {
    this.shared.removeCookie(SharedService.CURRENT_SUPPORT_PLAN);
  }

  openStop() {
    this.showStopForm = true;
  }

  async stop() {
    let plans = this.auth.user.plans.map(item => {
      if (item.plan_uid === this.plan.plan_uid) {
        item.stoppedAt = moment().tz('Asia/Tokyo').endOf('month').toDate().getTime();
        item.stopReason = this.stopReason
        return item
      } else {
        return item;
      }
    })

    let params = {
      uid: this.auth.user.uid,
      plans: plans
    }

    this.auth.toggleSpinner(true);
    await this.auth.updateUserData(params);
    this.auth.user.plans = plans

    let vparams = {
      uid: this.plan.vtuber.uid,
      supporters: this.plan.vtuber.supporters.map(item => {
        if (item.user_id === this.auth.user.uid) {
          item.stoppedAt = moment().tz('Asia/Tokyo').endOf('month').toDate().getTime();
          item.stopReason = this.stopReason
          return item
        } else {
          return item;
        }
      })
    }
    this.auth.updateUserData(vparams);

    // Sending Notification
    // const data = {
    //   message: moment().format('Y年MM月DD日 支援が終了しました。<br/>Y年MM月末日までは引き続きアバター通話等をご利用いただけます。'),
    //   sender: this.plan.vtuber.uid,
    //   type: 'message'
    // }

    // this.auth.user.chats.map(item => {
    //   this.cs.sendMessage(item, data, true, this.auth.user.uid, this.plan.vtuber.uid)
    // })

    // Sending Email User
    this.auth.sendEmail({
      to: this.auth.user.email,
      subject: emails.support_stop_subject.replace(/\[支援先のVTuber名\]/g, this.plan.vtuber.displayName),
      text: this.auth.getEmailTemplate(emails.support_stop.join("")).replace(/\[支援先のVTuber名\]/g, this.plan.vtuber.displayName)
                .replace(/\[支援プランタイトル\]/g, this.plan.plan.title)
                .replace(/\[支援金額\/月\]/g, this.plan.plan.amount + '円/月')
                .replace(/\[通話時間\/月\]/g, this.plan.plan.period + "分/月")
                .replace(/\[ユーザー名\]/g, this.auth.user.displayName)
                .replace(/\[支援を停止する理由\]/g, this.stopReason)
    })

    this.auth.toggleSpinner(false);
    this.shared.redirect('/user/plans');
  }

  formatStopAt(plan) {
    if (plan.stoppedAt) {
      return moment(plan.stoppedAt).tz('Asia/Tokyo').format("Y年MM月DD日");
    }

    if (plan.plan.delete) {
      let deleteAt = moment(plan.plan.delete.deleteAt + "-01 00:00:00").tz('Asia/Tokyo').add(-1, "d");
      return deleteAt.format("Y年MM月DD日");
    }

    return "";
  }
}
